import { getMachinesNames } from '@/api/machine';
import { ONE_HOUR_MS } from '@/lib/constants';
import { useQuery } from '@tanstack/react-query';

export function useMachinesNames(enabled = true) {
  return useQuery({
    queryKey: ['machinesNames'],
    queryFn: getMachinesNames,
    enabled,
    staleTime: ONE_HOUR_MS,
  });
}
